import { render, staticRenderFns } from "./SkillsStudent.vue?vue&type=template&id=0d0c4afd&scoped=true"
import script from "./SkillsStudent.vue?vue&type=script&lang=js"
export * from "./SkillsStudent.vue?vue&type=script&lang=js"
import style0 from "./SkillsStudent.vue?vue&type=style&index=0&id=0d0c4afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c4afd",
  null
  
)

export default component.exports